import { HttpResourceRef } from '@angular/common/http';
import { WritableSignal, effect, signal } from '@angular/core';

import { Messenger } from './service';

export function storedSignal<T>(key: string, def: T): WritableSignal<T> {
  let value: T;
  const existing = window.localStorage.getItem(key);
  if (existing === null) {
    value = def;
  } else {
    // Attempt to parse the stored value. If parsing fails, the default value might be a safer fallback
    // though for simple types like booleans/strings/numbers, JSON.parse is usually robust.
    value = JSON.parse(existing);
  }

  const result = signal(value);
  effect(() => {
    const value = result();

    window.localStorage.setItem(key, JSON.stringify(value));
  });
  return result;
}

export const storedResource = <T>(cr: HttpResourceRef<T>, key: string, messenger: Messenger) =>
  effect(() => {
    if (cr.error()) {
      console.error(cr.error());
      messenger.error('List of clients is unavailable');
    } else if (cr.value()) {
      window.localStorage.setItem(key, JSON.stringify(cr.value()));
    }
  });
